import React from "react";
import { Container, Col, Image, Row } from "react-bootstrap";
import { NavLink,useLocation } from "react-router-dom";

function Footer() {
  const { pathname } = useLocation();

  return (
    <div>
      <footer>
        <div className={pathname == "/login" || pathname == "/"  ? "rgc-footer" : "rgc-footer-inline"}></div>
        <div className={pathname == "/login" || pathname == "/"  ? "rgc-footer-opacity" : ""}></div>
         {/* {pathname == "/" ?
             <div id="footers">
             <div
               id="Rgc-Footer-Mobile"
               className="rgc-mobile-footer d-block d-lg-none"
             >
               <Row className="justify-content-center rgc-mobile-content p-3">
                 <Col>
                   <NavLink to="/">
                     <i class="fas fa-home"></i>
                     <span>صفحه اصلی</span>
                   </NavLink>
                 </Col>
   
                 <Col>
                   <NavLink to="/profile">
                     <i class="fas fa-user"></i>
                     <span>پروفایل</span>
                   </NavLink>
                 </Col>
    
                 <Col>
                   <NavLink to="/ads">
                     <i class="fa fa-bullhorn"></i>
                     <span>تبلیغات شهری</span>
                   </NavLink>
                 </Col>
               </Row>
             </div>
           </div>
           :
           ""
      } */}
   
      </footer>
    </div>
  );
}

export default Footer;
